/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Category_Not_FoundInputs */

const vi_error_shop_category_not_found = /** @type {(inputs: Error_Shop_Category_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục không còn tồn tại (có thể đã bị xoá).`)
};

/**

* @param {Error_Shop_Category_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_category_not_found = /** @type {((inputs?: Error_Shop_Category_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Category_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_category_not_found(inputs)
});